const e = (t) => /^0[^.\s]+$/u.test(t);
export {
  e as isZeroValueString
};
